/* eslint
    no-empty-function: "warn"
*/

// Platform imports
import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import Toggle from '@shared/easyfy.toggle';
import DropDown from '@webModules/dropdown';
import '@webModules/form';
// Meds imports
import Basket from '@webModules/basket';
import Search from '@webModules/search';
import '@webModules/medsBasket';
import '@webModules/header';
import '@webModules/bankID';
import '@webModules/medsABTest';
import '@webModules/clientSession';
import '@webModules/accordion';
import '@webModules/footer';
import '@webModules/productCard';
import '@webModules/productRecommendations';
import '@webModules/favourites';
import '@webModules/customerChat';
import '@webModules/gaEventListener';
import '@webModules/SiteMessageRotator';
import { TooltipPopover } from '@webModules/TooltipPopover';

// EventTracking
import { Ga4DataMapper } from '@webModules/eventMappers/dataMapper.ga4';
import { KlaviyoDataMapper } from '@webModules/eventMappers/dataMapper.klaviyo';
import { StatsDataMapper } from '@shared/easyfy.events/mappers/dataMapper.stats';
import Events, {
  ServiceNames
} from '@shared/easyfy.events/easyfy.eventhandler';
import { IDataMapper } from '@shared/easyfy.events/easyfy.eventdata';

namespace Easyfy.Page {
  @invoke
  class Global {
    private toggle: Toggle;

    onInit() {
      this.toggle = new Toggle('toggle');
      Basket.Basket.getBasket();
      new Search.Search();
      new DropDown.Dropdown();
      new Events.EasyfyEventHandler(
        new Map<string, IDataMapper>([
          [ServiceNames.Ga4, new Ga4DataMapper()],
          [ServiceNames.Klaviyo, new KlaviyoDataMapper()],
          [ServiceNames.Stats, new StatsDataMapper()]
        ])
      );

      globalEvent({
        type: 'click',
        event: {
          action: 'show-tooltip',
          callback: TooltipPopover.handleToggle
        }
      });
      TooltipPopover.init();

    }
  }
}
